import barba from '@barba/core';

import bannerInit from './modules/_section-titre';'./modules/_section-titre';

import './modules/_barba-transitions-vdeux';
import { navInitHome, navInitSingle, navDisable } from './modules/_navbar';
import otherAlbumsInit from './modules/_other-albums';
import focusInit from './modules/_focus-grid';
import bestofInit from './modules/_best-of-slider';
import livesInit from './modules/_lives-grid';
import nonInit from './modules/_abcdr-du-non-carrousel';
import hommageInit from './modules/_hommage';
import podcastsInit from './modules/_podcasts';

import './modules/_webgpu_texture';



bannerInit();
navInitHome();
navInitSingle();
otherAlbumsInit();
focusInit();
bestofInit();
livesInit();
nonInit();
hommageInit();
podcastsInit();

singleInit();


if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}

barba.hooks.before((data) => {
    navDisable();
    if(data.current.namespace === 'home') {
        window.localStorage.setItem('homeScrollPos', window.scrollY);
        // console.log(window.localStorage.getItem('homeScrollPos'));
        data.current.container.style.position = 'absolute';
        data.current.container.style.zIndex = -1;
        data.current.container.style.left = 0;
    } else {
        var postVisu = document.getElementById('post-visu');
        postVisu.style.top = 0;
        data.current.container.style.top =  -window.scrollY + "px";
        data.current.container.style.left = 0;
        data.current.container.style.position = 'fixed';
        data.current.container.style.overflow = 'visible';
        data.current.container.style.zIndex = 200;
        data.current.container.style.minWidth = "100%";
    }
});

barba.hooks.beforeLeave((data) => {
});

barba.hooks.leave((data) => {
});

barba.hooks.afterLeave((data) => {
});

barba.hooks.beforeEnter((data) => {
    if(data.next.namespace === 'home') {
        bannerInit();
        navInitHome();
        otherAlbumsInit();
        focusInit();
        bestofInit();
        livesInit();
        nonInit();
        hommageInit();
        podcastsInit();
        data.next.container.style.position = 'absolute';
        var prevScrollPos = window.localStorage.getItem('homeScrollPos');
        if (prevScrollPos){
            window.scrollTo(0,prevScrollPos);
        }
        // data.next.container.style.zIndex = -1;
    } else {
        data.next.container.style.position = 'fixed';
        data.next.container.style.top = 0;
        data.next.container.style.left = 0;
        data.next.container.style.minWidth = "100%";
    }
});

barba.hooks.afterEnter((data) => {
    // data.current.container.style.position = 'static';
    data.next.container.style.position = 'static';
});

barba.hooks.after((data) => {
    if (data.next.namespace == 'single') {
        navInitSingle();   
        singleInit();
        window.scrollTo({
            top: 0,
            behavior:'instant'
        });
    } 
    // if(data.next.namespace === 'home') {
    //     var prevScrollPos = window.localStorage.getItem('homeScrollPos');
    //     if (prevScrollPos){
    //         window.scrollTo(0,prevScrollPos);
    //     }
    // } 
})

function singleInit(){
    var singleVisu = document.querySelector('.pochette-visu');
    if (singleVisu) {
        singleVisu.classList.add('anim-init');
    }
}